import React, {Component} from 'react';
import {get} from "../../../api";
import Label from "../../auth/components/Label";
import {connect} from "react-redux";
import Big from 'big.js';
import {FormattedMessage} from "react-intl";

class ReferralSources extends Component {
    state = {
        traffic: [],
        limit: 5,
    }

    componentDidMount() {
        this.loadLeaderboard()
    }


    loadLeaderboard = () => {
        this.setState({loading: true})
        get('/analytics/traffic_sources')
            .then((data) => {
                let traffic = data.traffic.sort(this.trafficSorter)
                this.setState({loading: false, ...data, traffic})
            }).catch((e) => {
            this.setState({loading: false})
        })
    }

    trafficSorter = (a, b) => {
        return Big(b.visits || 0).cmp(a.visits || 0)
    }
    showFullList = () => {
        this.setState({limit: this.state.traffic.length})
    }

    render() {
        const {total_visits} = this.state;
        if (total_visits === 0) return null;

        return (<div className="card">
                <div className="card-body">
                    <Label><FormattedMessage id={"Traffic"}/></Label>
                    <div className={"display-4"}>{total_visits}</div>
                </div>
                <ul className="list-group list-group-flush">
                    {
                        this.state.traffic
                            .slice(0, this.state.limit)
                            .map((item) => {
                                const percent = Number(Big(item.visits || 0).div(total_visits).times(100).round().toString());
                                const colors = ['bg-info', 'bg-success', 'bg-warning', 'bg-primary'];
                                return <li className="list-group-item" key={item.hostname}>
                                    <div className="row">
                                        <div className={"col"}>
                                            {item.hostname}
                                        </div>
                                        <div className={"col-auto"}>
                                            {percent}%
                                        </div>
                                    </div>
                                    <div className={"progress-bar bg-info mt-1"}
                                         style={{height: 3, width: percent + "%"}}/>
                                </li>
                            })
                    }
                </ul>
                {
                    this.state.traffic.length > this.state.limit && <div className="text-center">
                        <button className={"btn btn-link"} onClick={this.showFullList}>
                            <FormattedMessage id={"Show all"}/>
                        </button>
                    </div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        affiliate_id: state.settings.affiliate_id
    }
}

export default connect(mapStateToProps)(ReferralSources);
